import { render, staticRenderFns } from "./ExchangeRateInput.vue?vue&type=template&id=3537a98a&"
import script from "./ExchangeRateInput.vue?vue&type=script&lang=js&"
export * from "./ExchangeRateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports